import { post } from "@insite/client-framework/Services/ApiService";
import { AddCollectAccountApiParameter, AddCollectAccountApiResult } from "@insite/client-framework/Types/ApiModels";

export async function addNewCollectAccount(addCollectAccountParameter: AddCollectAccountApiParameter) {
    const response = await post<AddCollectAccountApiParameter, AddCollectAccountApiResult>(
        "api/collect-accounts",
        addCollectAccountParameter,
    );
    return response;
}
